import { cache } from "react"
import { i18nConfig } from "@/i18Config"
import type { IContentItem } from "@kontent-ai/delivery-sdk"

import type { TextsList } from "@/types/kontent-generated/types/texts-list.generated"
import { getDeliveryClient } from "@/lib/kontent/client"

import { assertItemResponse, fetchKontent } from "../helpers"

export type TResolvedTextsList = {
  title: string
  textList: string
}

/**
 * Maps an already-fetched SDK item, avoiding a redundant Delivery API call
 * when the item was already resolved by a parent query's depth parameter.
 */
export async function GetTextsListFromItem(
  rawItem: IContentItem
): Promise<TResolvedTextsList> {
  const item = rawItem as TextsList
  return {
    title: item.elements.title.value,
    textList: item.elements.text_list.value,
  }
}

async function _fetchTextsList(
  codename: string,
  previewMode = false
): Promise<TResolvedTextsList> {
  return fetchKontent("TextsList", async () => {
    const client = getDeliveryClient(previewMode)
    const response = await client
      .item<TextsList>(codename)
      .languageParameter(i18nConfig.defaultLocale)
      .toPromise()

    const item = assertItemResponse(response, "TextsList")
    return GetTextsListFromItem(item)
  })
}

export const GetTextsList = cache(_fetchTextsList)
